import { RSNT_NAMESPACE_ID } from "src/constants";
import { PERSONALLOANS, HOME_EQUITY } from "src/features/LoansHome/Products/constants";
import {
    ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
    ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,
    ADVISOR_LENDING_LIMIT_EXCEEDS
} from "src/features/RBAC/Rules/permissionData";
import {
    APPLICANT,
    SMARTMATCH_TYPE_ADMIN,
    STATUS_SUBMITTED,
    STATUS_PRE_QUALIFIED,
    STATUS_BOOKING_COMPLETE,
    STATUS_FUNDING,
    STATUS_APPLICATION_STARTED,
    STATUS_UNDER_REVIEW,
    STATUS_WITHDRAW,
    STATUS_DECLINED,
    STATUS_CLEAR_TO_CLOSE_COMPLETED,
    STATUS_APPROVED,
    SMARTMATCH_TYPE_LOAN_OFFICER,
    STATUS_CLOSED_FOR_INCOMPLETENESS,
    SMARTMATCH_TYPE_CREDIT_MANAGER,
    STATUS_DENIAL_UNDER_REVIEW,
    STATUS_CREDIT_APPROVAL,
    STATUS_RECOMMENDED_DECLINE,
    STATUS_RECOMMENDED_APPROVE,
    STATUS_REQUEST_APPROVAL,
    STATUS_APPRAISAL_ORDER,
    STATUS_APPRAISAL_COMPLETE,
    STATUS_APPROVED_NOT_ACCEPTED,
    SMARTMATCH_TYPE_RATE_APPROVER,
    STATUS_DOCS_IN_EPRINT,
    STATUS_DOCS_IN_DOCUSIGN,
    STATUS_APPROVED_PENDING_CONDITIONS,
} from 'src/services/constants';
import {
    USER_ONBOARD_CDP_OFFICER,
    USER_ONBOARD_CLOSED_LOAN_EDIT_MANAGER,
    USER_ONBOARD_DIGITAL_RM
} from "src/services/constants/accounts";
import { rsntCommonStages } from "./common";
import { LOAN_PRM_ADVISOR_CREDIT_APPROVAL_NEEDED } from "src/features/RBAC/Rules/loanPermission";

const showWhenApprovedPending = {
    conditions: [
        {
            satisfies: "amount_lte",
            arguments: [
                {
                    "resource": "lending_terms",
                    "resource_value": "terms.amount",
                    "resource_formatter":""
                },
                {
                    "target_value": "25000"
                                  
                }
            ]
        }
    ]
}

const showWhenCredit = {
    conditions: [
        {
            satisfies: "amount_gt",
            arguments: [
                {
                    "resource": "lending_terms",
                    "resource_value": "terms.amount",
                },
                {
                    "target_value": "25000"

                }
            ]
        }
    ]
}
const stageUnderReviewHeloc = {
    name: STATUS_UNDER_REVIEW,
    display_name: STATUS_RECOMMENDED_DECLINE,
    order_id: 2,
    children: [
        {
            permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
            stages: [
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
        {
            stages: [
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stagePreQualifiedHeloc = {
    name: STATUS_PRE_QUALIFIED,
    display_name: STATUS_RECOMMENDED_APPROVE,
    order_id: 2,
    children: [
        {
            permission: LOAN_PRM_ADVISOR_CREDIT_APPROVAL_NEEDED,
            stages: [
                {
                    display_name: STATUS_CREDIT_APPROVAL,
                    name: STATUS_CREDIT_APPROVAL,
                },
                {
                    display_name: STATUS_WITHDRAW,
                    name: STATUS_WITHDRAW,
                },
                {
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                    name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
            ],
        },
        {
            permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
        
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
        {
            permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
          
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
        {
            permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
            stages: [
          
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
        {
            stages: [
                {
                    display_name: STATUS_APPROVED_PENDING_CONDITIONS,
                    name: STATUS_APPROVED_PENDING_CONDITIONS,
                    show_when: showWhenApprovedPending

                },
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stagePreQualifiedHelocAdmin = {
    name: STATUS_PRE_QUALIFIED,
    display_name: STATUS_RECOMMENDED_APPROVE,
    order_id: 2,
    children: [
        {
            permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
    
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
        {
            permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
   
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5,
                },
                {
                    display_name: STATUS_APPROVED_PENDING_CONDITIONS,
                    name: STATUS_APPROVED_PENDING_CONDITIONS,
                    show_when: showWhenApprovedPending

                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stageApprovalHeloc = {
    name: STATUS_REQUEST_APPROVAL,
    display_name: STATUS_REQUEST_APPROVAL,
    order_id: 2,
    children: [
        {
            permission: LOAN_PRM_ADVISOR_CREDIT_APPROVAL_NEEDED,
            stages: [
                {
                    display_name: STATUS_CREDIT_APPROVAL,
                    name: STATUS_CREDIT_APPROVAL,
                    show_when: showWhenCredit
                },
                {
                    display_name: STATUS_WITHDRAW,
                    name: STATUS_WITHDRAW,
                },
                {
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                    name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
            ],
        },
        {
            permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
            stages: [
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5,
                },
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                    order: 6,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
        {
            stages: [
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5,
                },
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                    order: 6,
                },
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
        {
            permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,

            stages: [
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5,
                },
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                    order: 6,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stageApprovalHelocAdmin = {
    name: STATUS_REQUEST_APPROVAL,
    display_name: STATUS_REQUEST_APPROVAL,
    order_id: 2,
    children: [
        {
            permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
            stages: [
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5,
                },
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                    order: 6,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
        {
            stages: [
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5,
                },
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                    order: 6,
                },
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stageCreditApprovalHeloc = {
    name: STATUS_CREDIT_APPROVAL,
    display_name: STATUS_CREDIT_APPROVAL,
    order_id: 3,
    children: [
        {
            permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
       
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5,
                },
                {
                    display_name: STATUS_APPROVED_PENDING_CONDITIONS,
                    name: STATUS_APPROVED_PENDING_CONDITIONS,
                    show_when: showWhenApprovedPending
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
          
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stageCreditApprovalHelocAdmin = {
    name: STATUS_CREDIT_APPROVAL,
    display_name: STATUS_CREDIT_APPROVAL,
    order_id: 3,
    children: [
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_PENDING_CONDITIONS,
                    display_name: STATUS_APPROVED_PENDING_CONDITIONS,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stageApprovedStaticConditionHeloc = {
    name: STATUS_APPROVED_PENDING_CONDITIONS,
    display_name: STATUS_APPROVED_PENDING_CONDITIONS,
    children: [
        {
            stages: [
                {
                    name: STATUS_APPRAISAL_ORDER,
                    display_name: STATUS_APPRAISAL_ORDER,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },

            ],
        },
    ],
};

const stageApprovedHeloc = {
    name: STATUS_APPROVED,
    display_name: STATUS_APPROVED,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_APPRAISAL_ORDER,
                    display_name: STATUS_APPRAISAL_ORDER,
                    order: 5,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                    display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stageAppraisalOrder = {
    name: STATUS_APPRAISAL_ORDER,
    display_name: STATUS_APPRAISAL_ORDER,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_APPRAISAL_COMPLETE,
                    display_name: STATUS_APPRAISAL_COMPLETE,
                    order: 5,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stageAppraisalComplete = {
    name: STATUS_APPRAISAL_COMPLETE,
    display_name: STATUS_APPRAISAL_COMPLETE,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                },
                {
                    name: STATUS_CREDIT_APPROVAL,
                    display_name: STATUS_CREDIT_APPROVAL,
                    show_when: showWhenCredit

                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                }
            ],
        },
    ],
};


const stageDenialUnderReviewHeloc = {
    name: STATUS_DENIAL_UNDER_REVIEW,
    display_name: STATUS_DENIAL_UNDER_REVIEW,
    children: [
        {
            stages: [
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stageStartedHeloc = {
    name: STATUS_APPLICATION_STARTED,
    display_name: STATUS_APPLICATION_STARTED,
    order_id: 1,
    children: [
        {
            stages: [
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
            ],
        },
    ],
};

const stageWithdrawnHeloc = {
    name: STATUS_WITHDRAW,
    display_name: STATUS_WITHDRAW,
    children: [
        {
            stages: [
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
            ],
        },
    ],
};

const stageDeclinedHeloc = {
    name: STATUS_DECLINED,
    display_name: STATUS_DECLINED,
    children: [
        {
            stages: [
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};


const stageClearToCloseLo = {
    name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
    display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_DOCS_IN_DOCUSIGN,
                    display_name: STATUS_DOCS_IN_DOCUSIGN,
                },
                {
                    name: STATUS_DOCS_IN_EPRINT,
                    display_name: STATUS_DOCS_IN_EPRINT,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                }
            ],
        },
    ],
};

const stageClearToClose = {
    name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
    display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_DOCS_IN_EPRINT,
                    display_name: STATUS_DOCS_IN_EPRINT,
                },
                {
                    name: STATUS_DOCS_IN_DOCUSIGN,
                    display_name: STATUS_DOCS_IN_DOCUSIGN,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stageFunding = {
    name: STATUS_FUNDING,
    display_name: STATUS_FUNDING,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_BOOKING_COMPLETE,
                    display_name: STATUS_BOOKING_COMPLETE,
                    order: 5,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stageSubmitted = {
    name: STATUS_SUBMITTED,
    display_name: STATUS_SUBMITTED,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                    order: 3,
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                },
            ],
        },
    ],
};

const stageDocsEPrint = {
    name: STATUS_DOCS_IN_EPRINT,
    display_name: STATUS_DOCS_IN_EPRINT,
    children: [
        {
            stages: [
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const stageDocsInDocuSign = {
    name: STATUS_DOCS_IN_DOCUSIGN,
    display_name: STATUS_DOCS_IN_DOCUSIGN,
    children: [
        {
            stages: [
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ],
        },
    ],
};

const cmStagesHeloc = {
    id: '154878745215745754',
    namespace_id: RSNT_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [HOME_EQUITY],
    roles: [SMARTMATCH_TYPE_CREDIT_MANAGER],
    stages: [
        stageStartedHeloc,
        stageSubmitted,
        stageUnderReviewHeloc,
        stagePreQualifiedHeloc,
        stageApprovalHeloc,
        stageCreditApprovalHeloc,
        stageApprovedStaticConditionHeloc,
        stageApprovedHeloc,
        stageAppraisalOrder,
        stageAppraisalComplete,
        stageClearToClose,
        stageDocsEPrint,
        stageDocsInDocuSign,
        stageDenialUnderReviewHeloc,
        stageFunding,
        {
            name: STATUS_BOOKING_COMPLETE,
            display_name: STATUS_BOOKING_COMPLETE,
        },
        stageWithdrawnHeloc,
        stageDeclinedHeloc,
        rsntCommonStages.stageNOI,
        rsntCommonStages.stagePrequalificationWithdrawn,
        rsntCommonStages.stageSoftDeclined,
    ],
} as any;

const adminStagesHeloc = {
    id: '154878745215745754',
    namespace_id: RSNT_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [HOME_EQUITY],
    roles: [SMARTMATCH_TYPE_ADMIN],
    stages: [
        stageStartedHeloc,
        stageSubmitted,
        stageUnderReviewHeloc,
        stagePreQualifiedHelocAdmin,
        stageApprovalHelocAdmin,
        stageCreditApprovalHelocAdmin,
        stageApprovedStaticConditionHeloc,
        stageApprovedHeloc,
        stageAppraisalOrder,
        stageAppraisalComplete,
        stageClearToClose,
        rsntCommonStages.stageDocsEPrintLoanCloseEdit,
        rsntCommonStages.stageDocsESignLoanCloseEdit,
        rsntCommonStages.stageApprovedNotAcceptedEdit,
        stageDenialUnderReviewHeloc,
        stageFunding,
        {
            name: STATUS_BOOKING_COMPLETE,
            display_name: STATUS_BOOKING_COMPLETE,
        },
        stageWithdrawnHeloc,
        stageDeclinedHeloc,
        rsntCommonStages.stageNOI,
        rsntCommonStages.stagePrequalificationWithdrawn,
        rsntCommonStages.stageSoftDeclined,
    ],
} as any;


const loStageHelocConfigs = {
    id: '154878745215745754',
    namespace_id: RSNT_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [HOME_EQUITY],
    roles: [SMARTMATCH_TYPE_LOAN_OFFICER],
    stages: [
        stageStartedHeloc,
        stageSubmitted,
        stageUnderReviewHeloc,
        stagePreQualifiedHeloc,
        stageApprovalHeloc,
        stageApprovedHeloc,
        stageAppraisalOrder,
        stageAppraisalComplete,
        stageClearToCloseLo,
        stageFunding,
        {
            name: STATUS_BOOKING_COMPLETE,
            display_name: STATUS_BOOKING_COMPLETE,
        },
        stageWithdrawnHeloc,
        stageDeclinedHeloc,
        rsntCommonStages.stageNOI,
        rsntCommonStages.stagePrequalificationWithdrawn,
        rsntCommonStages.stageSoftDeclined,
        stageApprovedStaticConditionHeloc,

    ],
} as any;

const cdpStageHelocConfigs = {
    id: '154878745215745754',
    namespace_id: RSNT_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [HOME_EQUITY],
    roles: [USER_ONBOARD_CDP_OFFICER],
    stages: [
        stageStartedHeloc,
        stageSubmitted,
        stageUnderReviewHeloc,
        stagePreQualifiedHeloc,
        stageApprovalHeloc,
        stageApprovedHeloc,
        stageAppraisalOrder,
        stageAppraisalComplete,
        rsntCommonStages.stageClearToCloseForCDP,
        stageFunding,
        {
            name: STATUS_BOOKING_COMPLETE,
            display_name: STATUS_BOOKING_COMPLETE,
        },
        stageWithdrawnHeloc,
        stageDeclinedHeloc,
        rsntCommonStages.stageNOI,
        rsntCommonStages.stagePrequalificationWithdrawn,
        rsntCommonStages.stageSoftDeclined,
    ],
} as any;

const drmStageHelocConfigs = {
    id: '154878745215745754',
    namespace_id: RSNT_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [HOME_EQUITY],
    roles: [USER_ONBOARD_DIGITAL_RM],
    stages: [
        stageStartedHeloc,
        stageSubmitted,
        stageUnderReviewHeloc,
        stagePreQualifiedHeloc,
        stageApprovalHeloc,
        stageApprovedHeloc,
        stageAppraisalOrder,
        stageAppraisalComplete,
        stageClearToCloseLo,
        stageWithdrawnHeloc,
        stageDeclinedHeloc,
        rsntCommonStages.stageNOI,
        rsntCommonStages.stagePrequalificationWithdrawn,
        rsntCommonStages.stageSoftDeclined,
    ],
} as any;

const rateApproverStageHelocConfigs = {
    id: '154878745215745754',
    namespace_id: RSNT_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [HOME_EQUITY],
    roles: [SMARTMATCH_TYPE_RATE_APPROVER],
    stages: [
        stageStartedHeloc,
        stageSubmitted,
        stageUnderReviewHeloc,
        stagePreQualifiedHeloc,
        stageCreditApprovalHelocAdmin,
        stageApprovedStaticConditionHeloc,
        stageApprovalHelocAdmin,
        stageApprovedHeloc,
        stageAppraisalOrder,
        stageAppraisalComplete,
        stageClearToCloseLo,
        stageFunding,
        {
            name: STATUS_BOOKING_COMPLETE,
            display_name: STATUS_BOOKING_COMPLETE,
        },
        stageWithdrawnHeloc,
        stageDeclinedHeloc,
        rsntCommonStages.stageNOI,
        rsntCommonStages.stagePrequalificationWithdrawn,
        rsntCommonStages.stageSoftDeclined,
    ],
} as any;


const closedLoanEditManager = {
  id: '154878745215745755',
  namespace_id: RSNT_NAMESPACE_ID,
  loan_type: [PERSONALLOANS],
  sub_loan_types: [
    HOME_EQUITY
  ],
  stages: [
    rsntCommonStages.stageDocsEPrintLoanCloseEdit,
    rsntCommonStages.stageDocsESignLoanCloseEdit,
    rsntCommonStages.stageApprovedNotAcceptedEdit,
    {
      name: STATUS_PRE_QUALIFIED,
      display_name: STATUS_RECOMMENDED_APPROVE,
    },
    {
      name: STATUS_UNDER_REVIEW,
      display_name: STATUS_RECOMMENDED_DECLINE,
    },
    rsntCommonStages.stageNOI,
    rsntCommonStages.stagePrequalificationWithdrawn,
  ],
  roles: [USER_ONBOARD_CLOSED_LOAN_EDIT_MANAGER],
} as any;

const applicantStagesHeloc = {
    id: '154878745215745754',
    namespace_id: RSNT_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [HOME_EQUITY],
    stages: [
        {
            name: STATUS_APPLICATION_STARTED,
            display_name: STATUS_APPLICATION_STARTED,
            order_id: 1,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_SUBMITTED,
                            display_name: STATUS_SUBMITTED,
                        },
                    ],
                },
            ],
        },
        {
            name: STATUS_SUBMITTED,
            display_name: STATUS_SUBMITTED,
            order_id: 2,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_UNDER_REVIEW,
                            display_name: STATUS_UNDER_REVIEW,
                        },
                    ],
                },
            ],
        },
        {
            name: STATUS_UNDER_REVIEW,
            display_name: STATUS_UNDER_REVIEW,
            order_id: 3,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_PRE_QUALIFIED,
                            display_name: STATUS_PRE_QUALIFIED,
                        },
                    ],
                },
            ],
        },
        {
            name: STATUS_PRE_QUALIFIED,
            display_name: STATUS_PRE_QUALIFIED,
            order_id: 4,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_APPROVED,
                            display_name: STATUS_APPROVED,
                        },
                    ],
                },
            ],
        },
        {
            name: STATUS_APPROVED,
            display_name: STATUS_APPROVED,
            order_id: 5,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                            display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                        },
                    ],
                },
            ],
        },
        {
            name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
            display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
            order_id: 6,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_FUNDING,
                            display_name: STATUS_FUNDING,
                        },
                    ],
                },
            ],
        },
        {
            name: STATUS_FUNDING,
            display_name: STATUS_FUNDING,
            order_id: 7,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_BOOKING_COMPLETE,
                            display_name: STATUS_BOOKING_COMPLETE,
                        },
                    ],
                },
            ],
        },
    ],
    roles: [APPLICANT],
} as any;

export const rsntHelocLoanStages = [
    loStageHelocConfigs,
    cdpStageHelocConfigs,
    applicantStagesHeloc,
    adminStagesHeloc,
    cmStagesHeloc,
    rateApproverStageHelocConfigs,
    drmStageHelocConfigs,
    closedLoanEditManager
]